import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import ShowCard from "./components/ShowCard";
import FeaturedArticles from "./components/FeaturedArticles";
import { hotShows, latestShows, funnyShows } from "@/mocks/varietyShows";
import { Link } from "react-router-dom";
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from "@/components/feature/StructuredData";

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        name="红桃影院-综艺在线观看 | 热门综艺真人秀免费看 | 最新搞笑综艺一网打尽"
        url="https://hongtao-movie.com"
        description="红桃影院综艺在线观看专区，热门综艺、真人秀免费看，最新综艺、搞笑综艺高清流畅不缓冲，每日欢乐不停。"
      />

      <main>
        <HeroSection />

        <CategoryNav />

        <section className="w-full px-4 md:px-6 py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  热门综艺推荐
                </h2>
                <p className="text-foreground-500 text-sm">大家都在看的爆款综艺，热度持续飙升</p>
              </div>
              <Link
                to="/category/zhenrenxiu"
                className="hidden sm:flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {hotShows.map((show) => (
                <ShowCard
                  key={show.id}
                  id={show.id}
                  title={show.title}
                  category={show.category}
                  imageUrl={show.imageUrl}
                  rating={show.rating}
                  updateInfo={show.updateInfo}
                  views={show.views}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  最新上线
                </h2>
                <p className="text-foreground-500 text-sm">每周新鲜综艺，第一时间更新</p>
              </div>
              <Link
                to="/category/zhenrenxiu"
                className="hidden sm:flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {latestShows.map((show) => (
                <ShowCard
                  key={show.id}
                  id={show.id}
                  title={show.title}
                  category={show.category}
                  imageUrl={show.imageUrl}
                  rating={show.rating}
                  updateInfo={show.updateInfo}
                  views={show.views}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
                  搞笑综艺专区
                </h2>
                <p className="text-foreground-500 text-sm">笑到停不下来，快乐就是这么简单</p>
              </div>
              <Link
                to="/category/gaoxiao"
                className="hidden sm:flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
              {funnyShows.map((show) => (
                <ShowCard
                  key={show.id}
                  id={show.id}
                  title={show.title}
                  category={show.category}
                  imageUrl={show.imageUrl}
                  rating={show.rating}
                  updateInfo={show.updateInfo}
                  views={show.views}
                />
              ))}
            </div>
          </div>
        </section>

        <FeaturedArticles />

        <section className="w-full px-4 md:px-6 py-16 bg-primary-500">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
              加入红桃影院，发现更多精彩综艺
            </h2>
            <p className="text-primary-100 text-sm md:text-base mb-8 max-w-lg mx-auto leading-relaxed">
              200+热门综艺，10000+高清剧集，随时随地畅享欢乐时光。每天更新，精彩不断！
            </p>
            <div className="flex items-center justify-center gap-3 flex-wrap">
              <Link
                to="/category/zhenrenxiu"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 hover:bg-background-100 text-primary-600 text-sm font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line w-4 h-4 flex items-center justify-center"></i>
                立即探索
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-600 hover:bg-primary-700 text-background-50 text-sm font-semibold rounded-full transition-all cursor-pointer whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}